import React from 'react';
import { SubSection, Rows, hasRows, num, pretty, yesno } from '../StatRows';
import RateBar from '../charts/RateBar';
import RangeRail from '../charts/RangeRail';

/* "Academics" accordion: the key rates as bars, then the test-score bands as
   fixed-axis rails with the qualitative rows beneath.
   Mirrors `academicRates` + `testScores` in MatchDetailSheet.swift. */

function build(detail) {
  const ac = detail.academics || {};
  return {
    rates: [
      { label: 'Acceptance', pct: ac.acceptance_rate, tone: 'green' },
      { label: 'Retention', pct: ac.retention, tone: 'green' },
      { label: 'Grad rate 6-yr', pct: ac.grad_rate_6yr, tone: 'blue' },
      { label: 'Grad rate 4-yr', pct: ac.grad_rate_4yr, tone: 'blue' },
      { label: 'Yield', pct: ac.yield_rate, tone: 'gray' },
      { label: 'Transfer-out', pct: ac.transfer_out_rate, tone: 'gray' },
    ],
    rails: [
      { label: 'SAT math', range: ac.sat_math_range, axisMin: 200, axisMax: 800 },
      { label: 'SAT reading', range: ac.sat_read_range, axisMin: 200, axisMax: 800 },
      { label: 'ACT', range: ac.act_range, axisMin: 1, axisMax: 36 },
    ],
    testRows: [
      { label: 'Test policy', value: pretty(ac.test_policy) },
      { label: 'Student : faculty', value: ac.student_faculty_ratio != null ? `${ac.student_faculty_ratio}:1` : null },
      { label: 'Institution type', value: pretty(ac.carnegie) },
      { label: 'Majors offered', value: num(ac.majors_count) },
      { label: 'Your major offered', value: yesno(ac.major_offered) },
    ],
  };
}

const anyRate = (rates) => rates.some((r) => r.pct != null);
const anyRail = (rails) => rails.some((r) => r.range && (r.range.low != null || r.range.high != null));

export function hasContent(detail) {
  const b = build(detail);
  return anyRate(b.rates) || anyRail(b.rails) || hasRows(b.testRows);
}

export default function AcademicsSection({ detail }) {
  const { rates, rails, testRows } = build(detail);

  return (
    <>
      <SubSection title="Academics — Key Rates" hasContent={anyRate(rates)}>
        <RateBar rows={rates} />
      </SubSection>

      <SubSection title="Test Scores (25th–75th)" hasContent={anyRail(rails) || hasRows(testRows)}>
        <RangeRail rails={rails} />
        <Rows rows={testRows} />
      </SubSection>
    </>
  );
}
